import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';
import theme from '../../theme';
import LogoSection from './LogoSection';
import Navigation from './Navigation';
import ActionsSection from './ActionsSection';
import HamburgerSection from './HamburgerSection';
import MobilePanelContainer from './MobilePanelContainer';
import MobilePanel from './MobilePanel';
import BalanceContainer from './BalanceContainer';
import { HEADER_TYPE } from './types';
import * as S from './styles';
const DefaultSkeleton = () => (React.createElement(S.Wrapper, { className: "navWrapper", "aria-label": "loading nav" },
    React.createElement(S.CustomHeader, null,
        React.createElement(S.TopNav, null,
            React.createElement(S.SectionWrapper, { "$hasDataSource": false },
                React.createElement(Skeleton, { variant: "rounded", width: 120, height: 24 }),
                React.createElement(Skeleton, { variant: "rounded", width: 24, height: 24 }))))));
const UnifiedNavigation = ({ dataSource }) => {
    const [mobilePanelDisplay, setMobilePanelDisplay] = useState(false);
    if (!dataSource) {
        return React.createElement(DefaultSkeleton, null);
    }
    const { type, logoItems, navItems, actionItems, customer, isHeaderDataLoading } = dataSource;
    const shouldShowPrivateLoader = type === HEADER_TYPE.Private && isHeaderDataLoading;
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(S.Wrapper, { className: "navWrapper" },
            React.createElement(S.CustomHeader, null,
                React.createElement(S.TopNav, null,
                    React.createElement(S.SectionWrapper, { "$type": type, "$hasDataSource": true },
                        React.createElement(LogoSection, { logoItems: logoItems }),
                        navItems ? (React.createElement(Navigation, { type: type, navItems: navItems, customer: customer, shouldShowPrivateLoader: shouldShowPrivateLoader })) : null),
                    actionItems && type !== HEADER_TYPE.Private ? (React.createElement(ActionsSection, { actionItems: actionItems })) : null,
                    navItems ? (React.createElement(HamburgerSection, { mobilePanelDisplay: mobilePanelDisplay, setMobilePanelDisplay: setMobilePanelDisplay, shouldShowPrivateLoader: shouldShowPrivateLoader })) : null),
                React.createElement(BalanceContainer, { type: type, customer: customer })),
            navItems ? (React.createElement(MobilePanelContainer, { mobilePanelDisplay: mobilePanelDisplay },
                React.createElement(MobilePanel, { type: type, navItems: navItems, customer: customer, actionItems: actionItems, setMobilePanelDisplay: setMobilePanelDisplay }))) : null)));
};
export default UnifiedNavigation;
//# sourceMappingURL=index.js.map